
<div class="navbar fixed-bottom navbar-expand-sm navbar-dark bg-dark p-0 m-0">

<div class="d-flex justify-content-between p-0 m-0 w-100">
  <div class="d-flex justify-content-sm-start">    
    <div class="d-flex justify-content-sm-start p-0">
      <div *ngIf="lastInfoEvent" class="badge-info text-nowrap m-sm-1 p-0 px-2">
        <span role="button" (click)="showEvent(lastInfoEvent)">
          <i class="fa fa-info-circle"></i>&nbsp;{{lastInfoEvent.message|shorten:80:'...'}}&nbsp;
        </span>
        <span class="font-smaller" *ngIf="infoEvents.length>1">&nbsp;({{infoEvents.length}})</span>
        <i class="fa fa-times" role="button" (click)="infoEvents.pop();lastInfoEvent=last(infoEvents);"></i>
      </div>
      <div *ngIf="lastSuccessEvent" class="badge-success text-nowrap m-sm-1 p-0 px-2">
        <span role="button" (click)="showEvent(lastSuccessEvent)">
          <i class="fa fa-check"></i>&nbsp;{{lastSuccessEvent.message|shorten:80:'...'}}&nbsp;
        </span>
        <span class="font-smaller" *ngIf="successEvents.length>1">&nbsp;({{successEvents.length}})</span>
        <i class="fa fa-times" role="button" (click)="successEvents.pop();lastSuccessEvent=last(successEvents);"></i>
      </div>
      <div *ngIf="lastErrorEvent" class="badge-danger text-nowrap m-sm-1 p-0 px-2">
        <span role="button" (click)="showEvent(lastErrorEvent)">
          <i class="fa fa-exclamation-triangle"></i>&nbsp;{{lastErrorEvent.message|shorten:80:'...'}}&nbsp;
        </span>
        <div *ngIf="errorEvents.length > 1"
            class="mb-1 pr-2 btn-group font-smaller" dropdown [dropup]="true" placement="right">
          <button id="button-dropup" dropdownToggle type="button" class="p-0 btn btn-primary"
              style="line-height:18px;" aria-controls="dropdown-dropup">
            ({{errorEvents.length}})
          </button>
          <ul id="dropdown-dropup" *dropdownMenu class="dropdown-menu badge-danger"
              role="menu" aria-labelledby="button-dropup">
            <li *ngFor="let errorEvent of errorEvents; index as index;" role="menuitem">
              <div role="button" (click)="showEvent(errorEvent)" >
                {{index+1}})&nbsp;{{errorEvent.message|shorten:80:'...'}}&nbsp;
              </div>
            </li>
          </ul>
        </div>
        <i class="fa fa-times" role="button" (click)="lastErrorEvent=null;errorEvents.length=0"></i>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-sm-end text-nowrap">
    <div *ngIf="user" class="d-flex justify-content-sm-end py-sm-1 text-white font-italic">
      <ng-container *ngIf="dialerService.bInitialized">
        <dialer-status [pythonAppInfo]="dialerService.dialerInfo" class="pr-2">          
        </dialer-status>
        <div class="text-warning pr-2" *ngIf="!dialerVersionOk">
          <i class="fa fa-exclamation-triangle"></i>&nbsp;Dialer not compatible
        </div>
      </ng-container>
      <app-scout-photos-status-bar class="pr-2"></app-scout-photos-status-bar>
      <div *ngIf="appState.isOfflineSubject.value&&!rxdbState.bAllOk; else connectionsStatus"
        title="Server and database are not available" class="pr-2">
          <i class="fa fa-unlink text-warning"></i>&nbsp;offline
      </div>
      <ng-template #connectionsStatus>
      <div *ngIf="rxdbState.readySubject.value" class="d-flex flex-row nav-item font-italic p-0">
        <div *ngIf="!rxdbState.bSynced" class="pr-2">
          <i class="fa fa-exclamation-triangle text-warning"></i>&nbsp;Not Syncronized
        </div>
        <div *ngIf="rxdbState.bActiveSync" class="pr-2">
          <i class="fa fa-spinner fa-spin"></i>&nbsp;Remote sync active...
        </div>
        <div *ngIf="!rxdbState.bAllOk; else dbOk" class="pr-2" title="Some or all database connection(s) down">
          <span class="icon-stack text-warning">
            <i class="fa fa-database fa-1x fa-stack-1x"></i>
            <i class="fa fa-slash fa-1x fa-stack-1x icon-strike-through"></i>
          </span>
          <span>
            {{rxdbState.httpRespWarningMsg}}
          </span>
        </div>
        <ng-template #dbOk>
          <div class="pr-2" title="Database connected">
            <i class="fa fa-database"></i>
          </div>
        </ng-template>
      </div>
      <div class="nav-item p-0">
        <div *ngIf="!appState.isOfflineSubject.value; else serverOffline" title="Server connected" class="pr-2">
          <i class="fa fa-server"></i>
        </div>
        <ng-template #serverOffline>
          <div title="No server connection" class="pr-2">
            <span class="icon-stack text-warning">
              <i class="fa fa-server fa-1x fa-stack-1x"></i>
              <i class="fa fa-slash fa-1x fa-stack-1x icon-strike-through"></i>
            </span>
            <span>
              offline
            </span>
          </div>
        </ng-template>
      </div>
    </ng-template>
    </div>
    <div class="d-flex justify-content-sm-end py-sm-1">
      <div *ngIf="user" class="nav-item text-white text-nowrap font-italic py-0 px-sm-1">
        <span *ngIf="env=='PROD'">Production</span>
        <span *ngIf="env=='DEV'">Development</span>
        <span *ngIf="env=='STAGE'">Staging</span>
        <span class="pl-sm-1" [ngClass]="{'text-danger':clientVersionMismatch}">v{{clientBuildInfo.version}}</span>
        <span *ngIf="clientVersionMismatch" class="text-warning">
          &nbsp;<i class="fa fa-exclamation-triangle"></i> v{{latestClientVersion}} expected
        </span>
        <ng-container *ngIf="!appState.isOfflineSubject.value&&(loginExpired||loginExpiring)">
          &nbsp;
          <i class="fa fa-exclamation-triangle text-warning"></i> <span class="pl-sm-1 py-1 m-0 text-warning" [title]="loginExpireMsg">Login {{loginExpired?'expired':'expiring'}}</span>
        </ng-container>
        &nbsp;
        <ng-container *ngIf="user?.role == 'admin'; else not_admin_user">
          <span class="p-1 m-0 badge-danger font-weight-bold"><i class="fa fa-user-cog"></i>&nbsp;&nbsp;ADMIN {{user?.email}}</span>
        </ng-container>
        <ng-template #not_admin_user>
          <span class="p-1 m-0"><i class="fa fa-user alert-info"></i>&nbsp;&nbsp;{{user?.email}}</span>
        </ng-template>
        &nbsp;
        <i *ngIf="!isElectron" title="logout" role="button" (click)="logout()" class="fa fa-sign-out-alt"></i>
      </div>
      <div *ngIf="!user" class="nav-item text-white font-italic py-0 px-3">        
        <i class="fa fa-user alert-warning"></i>&nbsp;&nbsp;Login required
      </div>
    </div>
  </div>
</div>

</div>